import dayjs from "dayjs";

import {
  AccountClientRow,
  AccountColumnLabels,
  AccountTypeCount,
  PieChartDataType,
  PieData,
} from "../types";
import { chartPieColors, COLUMN_DATE_FORMAT } from "./consts";

export type translatedContentConfigType = {
  language: string;
  translatedContent: AccountColumnLabels;
};

//TODO: to be replaced by server side
export const csvDataFormatter =
  ({
    translatedContent,
    redactedFields,
  }: translatedContentConfigType & { redactedFields: string[] }) =>
  (row: AccountClientRow) => {
    const {
      accountID: accountId,
      executionType: accountType,
      clientID: clientId,
      name,
      email,
      firstTradedDate,
      lastTradedDate,
      rebateAccountID,
    } = row;
    const csvRowDefinition: Record<string, string | number> = {
      [`${translatedContent?.acc} #`]: accountId,
      [`${translatedContent?.accType}`]: accountType,
      [`${translatedContent?.clientId}`]: clientId,
      [`${translatedContent?.name}`]: name,
      [`${translatedContent?.email}`]: email,
      [`${translatedContent?.firstTradedDate}`]: firstTradedDate
        ? dayjs(firstTradedDate).format(COLUMN_DATE_FORMAT)
        : "-",
      [`${translatedContent?.lastTradedDate}`]: lastTradedDate
        ? dayjs(lastTradedDate).format(COLUMN_DATE_FORMAT)
        : "-",
      [`${translatedContent?.rebateAccount}`]: rebateAccountID,
    };
    for (const redactedField of redactedFields) {
      if (
        Object.keys(csvRowDefinition).includes(
          translatedContent[redactedField as keyof AccountColumnLabels],
        )
      ) {
        delete csvRowDefinition[
          translatedContent[redactedField as keyof AccountColumnLabels]
        ];
      }
    }

    return csvRowDefinition;
  };

export const buildChartDataByType = (
  type: PieChartDataType,
  stats: {
    platformAccounts: AccountTypeCount[];
    accountsType: AccountTypeCount[];
  },
): PieData[] => {
  const source = stats[type];
  if (source.length === 0) return [];

  return source
    .map((item) => ({
      id: item.name,
      label: item.name,
      value: item.count || 0,
      color: chartPieColors.get(item.name.toLowerCase()) || "#000000",
    }))
    .sort((a, b) => b.value - a.value);
};
